import { render, staticRenderFns } from "./VerificationProcess.vue?vue&type=template&id=136afb25&scoped=true&"
import script from "./VerificationProcess.vue?vue&type=script&lang=js&"
export * from "./VerificationProcess.vue?vue&type=script&lang=js&"
import style0 from "./VerificationProcess.vue?vue&type=style&index=0&id=136afb25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136afb25",
  null
  
)

export default component.exports